/* ++++++++++ --------------- HELP PAGE : STYLES --------------- ++++++++++ */

export default theme => ({
    CustomModal: {
        width: '772px'
    },
    Footer: {
        float: 'right'
    },
    Error: {
        color: 'red'
    },
    Inline1: {
        display: 'inline-block',
        width: '60px',
        marginRight: '5px',
        verticalAlign: 'middle'
    },
    Inline2: {
        display: 'inline-block',
        width: '245px',
        verticalAlign: 'middle'
    }
});